const inputNameError = (scope, key) => {
  let inputName = key.split('.').reduce((acc, attr) => `${acc}[${attr}_attributes]`, '');

  inputName = inputName.slice(0, inputName.lastIndexOf('_attributes')).concat(']');

  return `${scope}${inputName}`;
};

export default inputNameError;
